export const groupDomain = {
  computed: {
    isInfantCare() {
      const levelID = this.ddlClass.split(',')
      const courseId = this.reportLevel || levelID?.[1]
      return courseId === 'CRS201400072'
    },
  },
  methods: {
    getDefaultGroupDomain() {
      return [
        { Domain: 'The Social Child 社会背景下的儿童' },
        { Domain: 'The Child as a Communicator (English) 善交流的儿童（英文）' },
        { Domain: 'The Child as a Communicator (Mandarin) 善交流的儿童（华文）' },
        { Domain: 'Online Translation of "The Child as a Communicator (Mandarin)" “善交流的儿童（华文）”在线翻译' },
        { Domain: 'The Thinking Child 好思考的儿童' },
        { Domain: 'The Physical Child 身体健康的儿童' },
        this.isInfantCare ? null : { Domain: 'Creative Expression and Enjoyment through the Arts 通过艺术创意表达，并享受艺术' },
        this.isInfantCare ? null : { Domain: 'The Child as an Agent of Change 与时俱进的儿童' },
      ].filter(Boolean)
    },
  },
}
